// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const trackSetIdentity = ({ userEmail }: { userEmail: string }) => {
  if (window.gtag) {
    window.gtag('set', {
      userEmail,
    })
  }
}
